import axios from "axios";
import AppConstants from "./AppConstants";

export default class CommonMethods {
  public static getRouteLink = (view: string) => {
    return `#${view}`;
  };

  public static sendMessage = (data: any) => {
    return axios.post(
      `${AppConstants.cloudlasResourceEndPoint}/api/ContactUs`,
      data
    );
  };

  public static logSiteVisit = async () => {
    if (window.location.href.toLowerCase().indexOf("cloudlas") > 0) {
      var ipInfo: any = {};
      var clientInfo: any = {};
      await axios.get("https://ipinfo.io/json").then((res: any) => {
        ipInfo = res.data;
        clientInfo = this.getclientInfo();
        // console.log(ipInfo);
        // console.log(clientInfo);
      });

      var dataToPost = {
        action: "Visit",
        oS: clientInfo?.os?.name,
        oSVersion: (clientInfo?.os?.version || "").toString(),
        browser: clientInfo?.browser?.name,
        browserVersion: (clientInfo?.browser?.version || "").toString(),
        iPAddress: ipInfo.ip,
        city: ipInfo.city,
        country: ipInfo.country,
        region: ipInfo.region,
        location: ipInfo.loc,
        timezone: ipInfo.timezone,
      };

      axios.post(
        `${AppConstants.cloudlasResourceEndPoint}api/UserActivities/Log`,
        dataToPost
      );
    }
  };

  public static getclientInfo = () => {
    "use strict";

    var module = {
      options: [],
      header: [
        navigator.platform,
        navigator.userAgent,
        navigator.appVersion,
        navigator.vendor,
        (window as any).opera,
      ],
      dataos: [
        { name: "Windows Phone", value: "Windows Phone", version: "OS" },
        { name: "Windows", value: "Win", version: "NT" },
        { name: "iPhone", value: "iPhone", version: "OS" },
        { name: "iPad", value: "iPad", version: "OS" },
        { name: "Kindle", value: "Silk", version: "Silk" },
        { name: "Android", value: "Android", version: "Android" },
        { name: "PlayBook", value: "PlayBook", version: "OS" },
        { name: "BlackBerry", value: "BlackBerry", version: "/" },
        { name: "Macintosh", value: "Mac", version: "OS X" },
        { name: "Linux", value: "Linux", version: "rv" },
        { name: "Palm", value: "Palm", version: "PalmOS" },
      ],
      databrowser: [
        { name: "Chrome", value: "Chrome", version: "Chrome" },
        { name: "Firefox", value: "Firefox", version: "Firefox" },
        { name: "Safari", value: "Safari", version: "Version" },
        { name: "Internet Explorer", value: "MSIE", version: "MSIE" },
        { name: "Opera", value: "Opera", version: "Opera" },
        { name: "BlackBerry", value: "CLDC", version: "CLDC" },
        { name: "Mozilla", value: "Mozilla", version: "Mozilla" },
      ],
      init: function () {
        var agent = this.header.join(" "),
          os = this.matchItem(agent, this.dataos),
          browser = this.matchItem(agent, this.databrowser);

        return { os: os, browser: browser };
      },
      matchItem: function (str: any, data: any) {
        var i = 0,
          j = 0,
          html = "",
          regex,
          regexv,
          match,
          matches,
          version;

        for (i = 0; i < data.length; i += 1) {
          regex = new RegExp(data[i].value, "i");
          match = regex.test(str);
          if (match) {
            regexv = new RegExp(data[i].version + "[- /:;]([\\d._]+)", "i");
            matches = str.match(regexv);
            version = "";
            if (matches) {
              if (matches[1]) {
                matches = matches[1];
              }
            }
            if (matches) {
              matches = matches.split(/[._]+/);
              for (j = 0; j < matches.length; j += 1) {
                if (j === 0) {
                  version += matches[j] + ".";
                } else {
                  version += matches[j];
                }
              }
            } else {
              version = "0";
            }
            return {
              name: data[i].name,
              version: parseFloat(version),
            };
          }
        }
        return { name: "unknown", version: 0 };
      },
    };

    var e = module.init();
    // console.log(navigator);
    // console.log(e);
    return e;
  };
}
